import { render, staticRenderFns } from "./LocationHistoryReport.vue?vue&type=template&id=8f2ed962&scoped=true&"
import script from "./LocationHistoryReport.vue?vue&type=script&lang=js&"
export * from "./LocationHistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./LocationHistoryReport.vue?vue&type=style&index=0&id=8f2ed962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2ed962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f2ed962')) {
      api.createRecord('8f2ed962', component.options)
    } else {
      api.reload('8f2ed962', component.options)
    }
    module.hot.accept("./LocationHistoryReport.vue?vue&type=template&id=8f2ed962&scoped=true&", function () {
      api.rerender('8f2ed962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/LocationHistoryReport.vue"
export default component.exports